import { TFunction } from '@mint-lib/i18n';

import type { SuggestionTabs } from '../types/suggestion.js';

type SuggestionTabType = {
  label: string;
  value: SuggestionTabs;
};

export const suggestionTabs = {
  ACTIVE: 'active,reworking',
  REWORKING: 'active,reworking',
  ACCEPTED: 'accepted,accepting',
  ACCEPTING: 'accepted,accepting',
  EXPIRED: 'expired',
  REJECTED: 'rejected',
  ERROR: 'error',
} as const;

export const getSuggestionTabs = (t: TFunction): SuggestionTabType[] => {
  return [
    { label: t('New'), value: suggestionTabs.ACTIVE },
    { label: t('Accepted'), value: suggestionTabs.ACCEPTED },
    { label: t('Expired'), value: suggestionTabs.EXPIRED },
    { label: t('Rejected'), value: suggestionTabs.REJECTED },
    { label: t('Error'), value: suggestionTabs.ERROR },
  ];
};
